import {APP} from 'constants/actions';
import {ActionType} from 'constants/flow/flowTypes';

import {sendReactPV} from 'libs/EEC/impression/impression';
import EECCartImpressions from 'sagas/EEC/EECCartImpressions/EECCartImpressions';
import {call, fork, takeEvery} from 'redux-saga/effects';
import {PageAppType} from 'reducers/app/pageApp/pageAppType';
import {getProductsECCData} from '../EECProductEvents/EECProductEvents';

export const CART_IMPRESSIONS_REDUCER = 'CART';
export const PRODUCT_IMPRESSIONS_REDUCER = 'PRODUCT';

/**
 * Reduce EEC page impression.
 * @param {string} pageType - Current page type
 */
export function* reduceImpressions(pageType = '') {
    const key = pageType.toUpperCase();

    if (key === CART_IMPRESSIONS_REDUCER) return;

    if (key === PRODUCT_IMPRESSIONS_REDUCER) {
        yield call(getProductsECCData);
    } else {
        yield call(sendReactPV, pageType);
    }
}

/**
 * Reduce EEC impression for cart page.
 */
export function* reduceImpressionsCartPage({payload: {page}}: ActionType<PageAppType>) {
    const key = page.toUpperCase();
    if (key === CART_IMPRESSIONS_REDUCER) yield fork(EECCartImpressions);
}

/**
 * Support saga function for category
 */
export default function* reduceImpressionsSaga() {
    yield takeEvery(APP.SAVE_LOCATION, reduceImpressionsCartPage);
}
